import { Box, TextField } from '@material-ui/core';
import React from 'react';
import { TitleInfo } from './TitleInfo';
interface ShortTextQuestionProps {
  title: string;
  clinicianInfo?: string;
  patientInfo?: string;
  handleInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  responseValue?: string;
  index: any;
}

export const ShortTextQuestion: React.FC<ShortTextQuestionProps> = ({
  title,
  handleInput,
  responseValue,
  clinicianInfo,
  patientInfo,
  index
}) => {
  return (
    <>
      <TitleInfo title={title} patientInfo={patientInfo} clinicianInfo={clinicianInfo} index={index} />
      <Box py={2}>
        <TextField
          label="Input your answer here"
          variant="outlined"
          inputProps={{ maxLength: 280 }}
          onChange={handleInput}
          value={responseValue}
          fullWidth
        />
      </Box>
    </>
  );
};
